export const walkscore = () => [
  {
    endpoint: 'walkscore',
    column: 'logo_url',
    default: 'N/A',
    label: 'Walk Score',
    type: 'IMAGE',
    width: 160,
  },
  {
    endpoint: 'walkscore',
    column: 'walkscore',
    default: 'N/A',
    label: 'Walk Score',
    type: 'TEXT',
  },
  {
    endpoint: 'walkscore',
    column: 'walkscore_description',
    label: 'Description',
    type: 'TEXT',
  },
  {
    label: 'Biking',
    type: 'SUBTITLE',
  },
  {
    endpoint: 'walkscore',
    column: 'bike',
    default: 'N/A',
    label: 'Bike Score',
    type: 'TEXT',
  },
  {
    endpoint: 'walkscore',
    column: 'bike_description',
    label: 'Description',
    type: 'TEXT',
  },
  {
    label: 'Transit',
    type: 'SUBTITLE',
  },
  {
    endpoint: 'walkscore',
    column: 'transit',
    label: 'Transit Score',
    default: 'N/A',
    type: 'TEXT',
  },
  {
    endpoint: 'walkscore',
    column: 'transit_description',
    label: 'Description',
    type: 'TEXT',
  },
  {
    endpoint: 'walkscore',
    column: 'help_link',
    label: 'How Walk Score Works',
    type: 'LINK',
  },
];
